import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import eyebrowThreading from "@/assets/treatments/eyebrow-threading.jpg";
import { Section } from "@/components/layout/section";
import { CoverImage } from "@/components/ui/cover-placeholder";
import { Text } from "@/components/ui/text";

interface TreatmentCategory {
  key: string;
  title: string;
  photo: string;
}

const TREATMENT_CATEGORIES: TreatmentCategory[] = [
  {
    key: "hair_salon",
    title: "Hair",
    photo:
      "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=720&q=80&auto=format&fit=crop",
  },
  {
    key: "nail_salon",
    title: "Nails",
    photo:
      "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=720&q=80&auto=format&fit=crop",
  },
  {
    key: "skin_care",
    title: "Skin",
    photo:
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=720&q=80&auto=format&fit=crop",
  },
  {
    key: "eyebrows_lashes",
    title: "Brows & lashes",
    photo: eyebrowThreading,
  },
  {
    key: "barbershop",
    title: "Barber",
    photo:
      "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=720&q=80&auto=format&fit=crop",
  },
  {
    key: "massage",
    title: "Massage",
    photo:
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=720&q=80&auto=format&fit=crop",
  },
  {
    key: "beauty_salon",
    title: "Beauty salons",
    photo:
      "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=720&q=80&auto=format&fit=crop",
  },
];

function CategoryGrid() {
  return (
    <Section width="wide" className="pt-2 pb-14" id="discover">
      <div className="mb-6 flex flex-wrap items-baseline justify-between gap-x-5 gap-y-2 md:mb-10">
        <Text as="h2" variant="display-l" className="text-[32px] md:text-[48px]">
          Explore treatments
        </Text>
        <Link
          to="/search"
          className="inline-flex min-h-11 items-center gap-2 text-[14px] font-medium text-ink no-underline hover:text-electric-800 focus-visible:outline-2 focus-visible:outline-electric-700 focus-visible:outline-offset-4"
        >
          Browse all
          <ArrowRight size={16} aria-hidden="true" />
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-4 md:gap-x-5 md:gap-y-8">
        {TREATMENT_CATEGORIES.map((category) => (
          <Link
            key={category.key}
            to="/search"
            search={{ category: category.key, category_name: category.title }}
            className="group min-w-0 text-ink no-underline focus-visible:outline-2 focus-visible:outline-electric-700 focus-visible:outline-offset-4"
          >
            <CoverImage
              src={category.photo}
              name={category.title}
              decorative
              loading="lazy"
              className="aspect-[4/3] rounded-sm [&_img]:object-bottom"
            />
            <h3 className="mt-3 font-display text-[18px] font-semibold leading-tight tracking-tight group-hover:underline group-hover:decoration-electric group-hover:underline-offset-4 md:text-[20px]">
              {category.title}
            </h3>
          </Link>
        ))}
      </div>
    </Section>
  );
}

export { CategoryGrid };
